module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPc()) ? _c('fzg-chuang-tou-pc') : _c('fzg-chuang-tou-mobile')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09673131"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/investment/FzgChuangTou.vue
// module id = 213
// module chunks = 0